<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="relative">
		<div class="vx-navbar-wrapper" :class="classObj">
			<vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon
					class="sm:inline-flex xl:hidden cursor-pointer p-2"
					icon="MenuIcon"
					@click.stop="showSidebar"
				/>
				<company-brand />
				<routing-type-drop-down positionLeft="left: 48%" v-if="showRoutingTypeDropDown" />
				<type-vehicle-drop-down
					v-if="showRoutingTypeDropDown"
					positionLeft="left: 58.5%"
				></type-vehicle-drop-down>
				<vs-spacer />
				<i18n class="mr-6" />
				<notification-drop-down />
				<profile-drop-down />
			</vs-navbar>
		</div>
	</div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import I18n from "./components/I18n.vue";
import SearchBar from "./components/SearchBar.vue";
import CartDropDown from "./components/CartDropDown.vue";
import NotificationDropDown from "@/components/notifications/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import RoutingTypeDropDown from "./components/RoutingTypeDropDown.vue";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import TypeVehicleDropDown from "./components/TypeVehicleDropDown.vue";
import CompanyBrand from "./components/CompanyBrand.vue";

export default {
	name: "the-navbar-vertical",
	props: {
		navbarColor: {
			type: String,
			default: "#fff",
		},
	},
	components: {
		TypeVehicleDropDown,
		Bookmarks,
		I18n,
		SearchBar,
		CartDropDown,
		NotificationDropDown,
		ProfileDropDown,
		RoutingTypeDropDown,
		CompanyBrand,
	},
	computed: {
		navbarColorLocal() {
			return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor;
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		textColor() {
			return {
				"text-white":
					(this.navbarColor !== "#10163a" && this.$store.state.theme === "dark") ||
					(this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		showRoutingTypeDropDown() {
			return this.$store.state.moduleCompanyConfigCrud.routing_type_drop_down;
		},
		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth == "default") return "navbar-default";
			else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
			else if (this.verticalNavMenuWidth) return "navbar-full";
		},
	},
	watch: {
		$route(to) {
			const routesNameList = [
				"dashboard-router",
				"dashboard-optimization-options",
				"app-optimization",
				"optimization-map",
				"app-reoptimization",
			];
			if (routesNameList.includes(to.name)) {
				this.$store.commit("moduleCompanyConfigCrud/TOGGLE_ROUTING_TYPE_DROP_DOWN", true);
			} else {
				this.$store.commit("moduleCompanyConfigCrud/TOGGLE_ROUTING_TYPE_DROP_DOWN", false);
			}
		},
	},
	methods: {
		showSidebar() {
			this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
		},
	},
	created() {
		// Registra el modulo
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
	},
};
</script>
